module.exports = __webpack_public_path__ + "img/IMG_1492.8f386f4b.jpeg";